import { ArrowRight, Phone } from 'lucide-react'
import { business } from '../../config/business'
import { trackEvent } from '../../lib/gtag'
import Button from '../ui/Button'

export default function CtaBanner() {
  return (
    <section className="bg-navy-800 py-20">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="font-heading font-bold text-white text-4xl md:text-5xl mb-4">
          Ready to Get Started?
        </h2>
        <p className="text-ink-300 text-lg mb-10 max-w-lg mx-auto">
          Get a free quote today — we'll get back to you fast, usually within a few hours.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button variant="primary" size="lg" as="a" href="#contact">
            Get a Free Quote
            <ArrowRight size={18} />
          </Button>
          <Button
            variant="outline-white"
            size="lg"
            as="a"
            href={`tel:${business.phone}`}
            onClick={() => trackEvent('phone_call_click', { method: 'tel_link' })}
          >
            <Phone size={18} />
            {business.phoneDisplay}
          </Button>
        </div>
      </div>
    </section>
  )
}
